export default () => ({
  actions: {
    display: 'flex'
  },
  action: {
    paddingRight: 16
  }
});
